"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceHappoScreenshot = forceHappoScreenshot;
exports.isHappoRun = void 0;
exports.setDefaultDelay = setDefaultDelay;
exports.setRenderTimeoutMs = setRenderTimeoutMs;
exports.setShouldWaitForCompletedEvent = setShouldWaitForCompletedEvent;
exports.setThemeSwitcher = setThemeSwitcher;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _excluded = ["themes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _require = require('./constants'),
  SB_ROOT_ELEMENT_SELECTOR = _require.SB_ROOT_ELEMENT_SELECTOR;
var time = window.happoTime || {
  originalDateNow: Date.now,
  originalSetTimeout: window.setTimeout.bind(window)
};
var ASYNC_TIMEOUT = 100;
var renderTimeoutMs = 2000;
var examples;
var currentIndex = 0;
var defaultDelay;
var themeSwitcher;
var forcedHappoScreenshotSteps;
var shouldWaitForCompletedEvent = true;
function waitForSomeContent(_x) {
  return _waitForSomeContent.apply(this, arguments);
}
function _waitForSomeContent() {
  _waitForSomeContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(elem) {
    var start,
      html,
      duration,
      _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            start = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : time.originalDateNow();
            html = elem.innerHTML.trim();
            duration = time.originalDateNow() - start;
            if (!(html === '' && duration < ASYNC_TIMEOUT)) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", new Promise(function (resolve) {
              return time.originalSetTimeout(function () {
                return resolve(waitForSomeContent(elem, start));
              }, 10);
            }));
          case 5:
            return _context2.abrupt("return", html);
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _waitForSomeContent.apply(this, arguments);
}
function waitForWaitFor(_x2) {
  return _waitForWaitFor.apply(this, arguments);
}
function _waitForWaitFor() {
  _waitForWaitFor = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(waitFor) {
    var start,
      duration,
      _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            start = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : time.originalDateNow();
            duration = time.originalDateNow() - start;
            if (!(!waitFor() && duration < renderTimeoutMs)) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", new Promise(function (resolve) {
              return time.originalSetTimeout(function () {
                return resolve(waitForWaitFor(waitFor, start));
              }, 50);
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _waitForWaitFor.apply(this, arguments);
}
function getExamples() {
  return _getExamples.apply(this, arguments);
}
function _getExamples() {
  _getExamples = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var storyStore;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            storyStore = window.__STORYBOOK_CLIENT_API__._storyStore;
            if (storyStore.extract) {
              _context4.next = 3;
              break;
            }
            throw new Error('Missing Storybook Client API');
          case 3:
            if (!storyStore.cacheAllCSFFiles) {
              _context4.next = 6;
              break;
            }
            _context4.next = 6;
            return storyStore.cacheAllCSFFiles();
          case 6:
            return _context4.abrupt("return", Object.values(storyStore.extract()).map(function (_ref4) {
              var id = _ref4.id,
                kind = _ref4.kind,
                story = _ref4.story,
                parameters = _ref4.parameters;
              if (parameters.happo === false) {
                return;
              }
              var delay = defaultDelay;
              var waitForContent;
              var waitFor;
              var beforeScreenshot;
              var afterScreenshot;
              var targets;
              var themes;
              if ((0, _typeof2["default"])(parameters.happo) === 'object' && parameters.happo !== null) {
                delay = parameters.happo.delay || defaultDelay;
                waitForContent = parameters.happo.waitForContent;
                waitFor = parameters.happo.waitFor;
                beforeScreenshot = parameters.happo.beforeScreenshot;
                afterScreenshot = parameters.happo.afterScreenshot;
                targets = parameters.happo.targets;
                themes = parameters.happo.themes;
              }
              return {
                component: kind,
                variant: story,
                storyId: id,
                delay: delay,
                waitForContent: waitForContent,
                waitFor: waitFor,
                beforeScreenshot: beforeScreenshot,
                afterScreenshot: afterScreenshot,
                targets: targets,
                themes: themes
              };
            }).filter(Boolean).reduce(function (result, _ref5) {
              var themes = _ref5.themes,
                rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded);
              if (!themes) {
                result.push(rest);
              } else {
                themes.forEach(function (theme) {
                  result.push(_objectSpread(_objectSpread({}, rest), {}, {
                    variant: "".concat(rest.variant, " [").concat(theme, "]"),
                    theme: theme
                  }));
                });
              }
              return result;
            }, []).sort(function (a, b) {
              var aCompare = "".concat(a.theme, "-").concat(a.storyId);
              var bCompare = "".concat(b.theme, "-").concat(b.storyId);
              if (aCompare === bCompare) {
                return 0;
              }
              return aCompare < bCompare ? -1 : 1;
            }));
          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getExamples.apply(this, arguments);
}
function filterExamples(all) {
  if (initConfig.chunk) {
    var examplesPerChunk = Math.ceil(all.length / initConfig.chunk.total);
    var startIndex = initConfig.chunk.index * examplesPerChunk;
    var endIndex = startIndex + examplesPerChunk;
    all = all.slice(startIndex, endIndex);
  }
  if (initConfig.targetName) {
    all = all.filter(function (e) {
      if (!e.targets || !Array.isArray(e.targets)) {
        // This story hasn't been filtered for specific targets
        return true;
      }
      return e.targets.includes(initConfig.targetName);
    });
  }
  if (initConfig.only) {
    all = all.filter(function (e) {
      return e.component === initConfig.only.component && e.variant === initConfig.only.variant;
    });
  }
  return all;
}
var initConfig = {};
window.happo = {};
window.happo.init = function (config) {
  initConfig = config;
};
function renderStory(story) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force;
  var channel = window.__STORYBOOK_ADDONS_CHANNEL__;
  var isPlaying = false;
  return new Promise(function (resolve) {
    var timeout = time.originalSetTimeout(resolve, renderTimeoutMs);
    function handleRenderPhaseChanged(ev) {
      console.log(ev);
      if (ev.newPhase === 'completed') {
        channel.off('storyRenderPhaseChanged', handleRenderPhaseChanged);
        clearTimeout(timeout);
        return resolve();
      }
      if (ev.newPhase === 'errored' && isPlaying && forcedHappoScreenshotSteps) {
        channel.off('storyRenderPhaseChanged', handleRenderPhaseChanged);
        clearTimeout(timeout);
        return resolve({
          pausedAtStep: forcedHappoScreenshotSteps[forcedHappoScreenshotSteps.length - 1]
        });
      }
      if (ev.newPhase === 'playing') {
        isPlaying = true;
      }
    }
    if (shouldWaitForCompletedEvent) {
      channel.on('storyRenderPhaseChanged', handleRenderPhaseChanged);
    }
    if (force) {
      channel.emit('forceRemount', story);
    } else {
      channel.emit('setCurrentStory', story);
    }
    if (!shouldWaitForCompletedEvent) {
      time.originalSetTimeout(function () {
        clearTimeout(timeout);
        resolve();
      }, 0);
    }
  });
}
window.happo.nextExample = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
  var _examples$currentInde, component, rawVariant, storyId, delay, waitForContent, waitFor, beforeScreenshot, theme, variant, pausedAtStep, docsRootElement, rootElement, _ref3, afterScreenshot, renderResult;
  return _regenerator["default"].wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (examples) {
            _context.next = 6;
            break;
          }
          _context.t0 = filterExamples;
          _context.next = 4;
          return getExamples();
        case 4:
          _context.t1 = _context.sent;
          examples = (0, _context.t0)(_context.t1);
        case 6:
          if (!(currentIndex >= examples.length)) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          _examples$currentInde = examples[currentIndex], component = _examples$currentInde.component, rawVariant = _examples$currentInde.variant, storyId = _examples$currentInde.storyId, delay = _examples$currentInde.delay, waitForContent = _examples$currentInde.waitForContent, waitFor = _examples$currentInde.waitFor, beforeScreenshot = _examples$currentInde.beforeScreenshot, theme = _examples$currentInde.theme;
          variant = rawVariant;
          _context.prev = 10;
          docsRootElement = document.getElementById('docs-root');
          if (docsRootElement) {
            docsRootElement.setAttribute('data-happo-ignore', 'true');
          }
          rootElement = document.querySelector(SB_ROOT_ELEMENT_SELECTOR);
          rootElement.setAttribute('data-happo-ignore', 'true');
          _ref3 = examples[currentIndex - 1] || {}, afterScreenshot = _ref3.afterScreenshot;
          if (!(typeof afterScreenshot === 'function')) {
            _context.next = 25;
            break;
          }
          _context.prev = 17;
          _context.next = 20;
          return afterScreenshot({
            rootElement: rootElement
          });
        case 20:
          _context.next = 25;
          break;
        case 22:
          _context.prev = 22;
          _context.t2 = _context["catch"](17);
          console.error('Failed to invoke afterScreenshot hook', _context.t2);
        case 25:
          _context.next = 27;
          return renderStory({
            kind: component,
            story: rawVariant,
            storyId: storyId
          }, {
            force: !!forcedHappoScreenshotSteps
          });
        case 27:
          _context.t3 = _context.sent;
          if (_context.t3) {
            _context.next = 30;
            break;
          }
          _context.t3 = {};
        case 30:
          renderResult = _context.t3;
          pausedAtStep = renderResult.pausedAtStep;
          if (pausedAtStep) {
            variant = "".concat(variant, "-").concat(pausedAtStep);
          } else {
            forcedHappoScreenshotSteps = undefined;
          }
          if (!(theme && themeSwitcher)) {
            _context.next = 36;
            break;
          }
          _context.next = 36;
          return themeSwitcher(theme, window.__STORYBOOK_ADDONS_CHANNEL__);
        case 36:
          _context.next = 38;
          return waitForSomeContent(rootElement);
        case 38:
          if (!/sb-show-errordisplay/.test(document.body.className)) {
            _context.next = 42;
            break;
          }
          // It's possible that the error is from unmounting the previous story. We
          // can try re-rendering in this case.
          window.__STORYBOOK_ADDONS_CHANNEL__.emit('forceReRender');
          _context.next = 42;
          return waitForSomeContent(rootElement);
        case 42:
          if (!(beforeScreenshot && typeof beforeScreenshot === 'function')) {
            _context.next = 51;
            break;
          }
          _context.prev = 43;
          _context.next = 46;
          return beforeScreenshot({
            rootElement: rootElement
          });
        case 46:
          _context.next = 51;
          break;
        case 48:
          _context.prev = 48;
          _context.t4 = _context["catch"](43);
          console.error('Failed to invoke beforeScreenshot hook', _context.t4);
        case 51:
          _context.next = 53;
          return new Promise(function (resolve) {
            return time.originalSetTimeout(resolve, delay);
          });
        case 53:
          if (!waitFor) {
            _context.next = 56;
            break;
          }
          _context.next = 56;
          return waitForWaitFor(waitFor);
        case 56:
          return _context.abrupt("return", {
            component: component,
            variant: variant,
            waitForContent: waitForContent
          });
        case 59:
          _context.prev = 59;
          _context.t5 = _context["catch"](10);
          console.warn(_context.t5);
          return _context.abrupt("return", {
            component: component,
            variant: variant
          });
        case 63:
          _context.prev = 63;
          if (!pausedAtStep) {
            currentIndex++;
          }
          return _context.finish(63);
        case 66:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[10, 59, 63, 66], [17, 22], [43, 48]]);
}));
function forceHappoScreenshot(stepLabel) {
  if (!currentIndex) {
    console.log("Ignoring forceHappoScreenshot with step label \"".concat(stepLabel, "\" since we are not currently rendering for Happo"));
    return;
  }
  if (!stepLabel) {
    throw new Error('Missing stepLabel argument. Make sure to pass a string as the first argument to this function. E.g. `forceHappoScreenshot("modal open")`');
  }
  if (forcedHappoScreenshotSteps && forcedHappoScreenshotSteps.includes(stepLabel)) {
    // ignore, this step has already been handled
    return;
  }
  forcedHappoScreenshotSteps = forcedHappoScreenshotSteps || [];
  forcedHappoScreenshotSteps.push(stepLabel);
  var e = new Error("Forced screenshot with label \"".concat(stepLabel, "\""));
  e.type = 'ForcedHappoScreenshot';
  e.step = stepLabel;
  console.log('Forcing happo screenshot', stepLabel);
  throw e;
}
function setDefaultDelay(delay) {
  defaultDelay = delay;
}
function setRenderTimeoutMs(timeoutMs) {
  renderTimeoutMs = timeoutMs;
}
function setThemeSwitcher(func) {
  themeSwitcher = func;
}
function setShouldWaitForCompletedEvent(swfce) {
  shouldWaitForCompletedEvent = swfce;
}
var isHappoRun = function isHappoRun() {
  return window.__IS_HAPPO_RUN;
};
exports.isHappoRun = isHappoRun;